import { render, staticRenderFns } from "./ListaEmpresa.vue?vue&type=template&id=22a7d82c&scoped=true"
import script from "./ListaEmpresa.vue?vue&type=script&lang=js"
export * from "./ListaEmpresa.vue?vue&type=script&lang=js"
import style0 from "./ListaEmpresa.vue?vue&type=style&index=0&id=22a7d82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7d82c",
  null
  
)

export default component.exports